import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Derives a CSS `aspect-ratio` value (e.g. "3338 / 2684") from an artwork's
 * actual photo pixel dimensions (`image_width`/`image_height`, read
 * server-side from the uploaded file). Used to reserve layout space for
 * artwork images before they load, preventing the page height (and
 * smooth-scroll bounds) from jumping as each image decodes.
 *
 * Deliberately NOT derived from the artwork's physical `dimensions` field
 * (the framed/canvas size in cm) -- that measurement has no reliable
 * relationship to how the photograph itself is cropped or oriented, and
 * using it produced mismatched boxes (blank gaps / apparent cropping).
 * Falls back to a portrait default when pixel dimensions are missing.
 */
export function getArtworkAspectRatio(artwork, fallback = '4 / 5') {
  const w = artwork?.image_width;
  const h = artwork?.image_height;
  if (!w || !h) return fallback;
  return `${w} / ${h}`;
}
